import { FONT_WEIGHTS } from '@/styles'
import { SxProps } from '@mui/material'
import { headerClasses } from '../Header.data'

interface HeaderActionsStyles {
  actionWrapper: SxProps
  desktopActions: SxProps
  button: SxProps
  buttonText: SxProps
  cartButton: SxProps
  cartCounterWrapper: SxProps
  cartCounter: SxProps
}

export const headerActionsStyles: HeaderActionsStyles = {
  actionWrapper: {
    display: { xs: 'none', lg: 'flex' },
    gap: 1.5,
    [`&.${headerClasses.hasPackage}`]: {
      display: 'flex',
    },
  },
  desktopActions: {
    display: { xs: 'none', lg: 'flex' },
    gap: 1.5,
    alignItems: 'center',
  },
  button: {
    py: 1,
    px: 1.75,
  },
  buttonText: {
    typography: 'textSm',
    fontWeight: FONT_WEIGHTS.SEMI_BOLD,
  },
  cartButton: {
    position: 'relative',
    '.icon': {
      width: 20,
      color: 'pageTheme.secondaryColor',
    },
  },
  cartCounterWrapper: {
    position: 'absolute',
    top: 0,
    right: 0,
    borderRadius: '50%',
    width: 16,
    height: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'background.default',
  },
  cartCounter: {
    typography: 'textXsSemibold',
    color: 'utils.green600',
  },
}
